<div class="section">
  <div class="row">
    <div class="col-12">
      <h3 class="title-with-icon">
        <svg-icon src="assets/images/icons/performance.svg" class="black-medium"></svg-icon>
        <span>{{ "Wired.Alerts.Title" | translate }}</span>
      </h3>
      <ng-container>
        @if (!alerts().length) {
          <div class="card">{{ "Wired.Alerts.NoAlerts" | translate }}</div>
        } @else {
          <div class="card">
            @for (alert of alerts(); track alert) {
              <h3>{{ alert.summary }}</h3>
              <div>
                {{ "Wired.Alerts.StartedAt" | translate }} <i>{{ alert.startsAt | date: "short" }}</i>
              </div>
              <div>
                {{ "Wired.Alerts.UpdatedAt" | translate }} <i>{{ alert.updatedAt | date: "short" }}</i>
              </div>
            }
          </div>
        }
      </ng-container>
    </div>
  </div>
</div>
